const Buttons = ({ buttonData, activebtn, handleClick }) => {
  return (
    <div>
      {buttonData.map((item, index) => {
        const classname = activebtn == item.name ? "fbtnActive" : null;
        return (
          <p
            key={index}
            className={`activity-trending-btn ${classname}`}
            onClick={(e) => {
              e.stopPropagation();
              handleClick(item.value);
            }}
          >
            {item.name}
          </p>
        );
      })}
    </div>
  );
};

export default Buttons;
